import(/* webpackMode: "eager" */ "/app/next/app/[root]/(standard)/error.tsx");
